import React from "react";

import "./style.css";

const SvgComponent = (props) => (
  <div className="logo">
    <svg className="logoSvg" viewBox="17 14 83 81" fill="none" {...props}>
      <ellipse
        rx={16.035}
        ry={16.988}
        transform="matrix(.76059 -.67957 .5828 .79022 83.603 32.696)"
        fill="#0B1726"
      />
      <ellipse
        rx={16.035}
        ry={16.988}
        transform="matrix(.76059 -.67957 .5828 .79022 34.176 76.857)"
        fill="#0B1726"
      />
      <path
        d="M93.474 24.405a.56.56 0 00.076-.736l-2.687-3.497c-.165-.215-.467-.233-.674-.041a.56.56 0 00-.076.735l2.39 3.109-2.998 2.778a.56.56 0 00-.076.736c.165.214.466.233.673.041l3.372-3.125zM42.293 69.97c2.164-12.06 3.801-21.081 5.7-27.811 1.9-6.732 4.038-11.075 7.148-13.854 3.106-2.775 7.262-4.061 13.35-4.473 6.09-.413 14.024.053 24.63.703l.108-1.04c-10.584-.649-18.583-1.12-24.743-.704-6.163.418-10.574 1.728-13.928 4.724-3.349 2.993-5.562 7.595-7.48 14.39-1.918 6.797-3.565 15.884-5.725 27.921l.94.144z"
        fill="#3C419F"
      />
      <path
        d="M27.058 80.218a.56.56 0 00-.076.735l2.688 3.497c.164.215.466.233.673.041a.56.56 0 00.076-.735l-2.39-3.109 2.998-2.778a.56.56 0 00.076-.736c-.165-.214-.466-.233-.673-.041l-3.372 3.126zM78.24 34.651c-2.165 12.059-3.802 21.08-5.701 27.81-1.9 6.732-4.038 11.075-7.148 13.854-3.106 2.775-7.262 4.061-13.35 4.473-6.09.413-14.024-.053-24.63-.703l-.108 1.04c10.584.649 18.583 1.12 24.744.704 6.162-.418 10.573-1.728 13.927-4.724 3.349-2.992 5.562-7.595 7.48-14.39 1.918-6.797 3.565-15.884 5.726-27.92l-.94-.144z"
        fill="#3C419F"
      />
    </svg>
    <span className="logoText">vieu</span>
  </div>
);

export default SvgComponent;
